import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'lowest_wage_paid_regular_work'

export const dataPointDefinition = {
  retracedId: 'lowest_wage_paid_regular_work',
  name: 'What is the lowest wage paid for regular work at the site?',
  description: 'The lowest wage paid to any worker for regular work at the facility, in local currency.',
  meta: {},
  fieldTypeId: 'NUMBER_DYNAMIC_CURRENCY_WITH_YEAR',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      unit: {
        type: 'string',
      },
      value: {
        type: 'number',
      },
      year: {
        type: 'number',
        minimum: 1000,
        maximum: 9999,
      },
    },
    required: ['value', 'year', 'unit'],
  },
  externalIds: [],
  sortingId: 37800,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
